// \src\pages\home\components\BrandsCarousel.tsx

import { useAdmin } from "@/context/AdminContext";

export default function BrandsCarousel() {
  const { data } = useAdmin();
  const doubled = [...data.brands, ...data.brands];

  return (
    <section className="w-full py-10 bg-background-100 border-y border-background-200 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 mb-6 text-center">
        <p className="text-foreground-500 text-xs font-label uppercase tracking-widest">
          Trabalhamos com as melhores marcas do mercado
        </p>
      </div>
      <div className="relative w-full overflow-hidden">
        <div
          className="flex gap-10 w-max brands-track animate-scroll-right"
          style={{ animationDuration: "35s" }}
        >
          {doubled.map((brand, i) => (
            <div
              key={`${brand.id}-${i}`}
              className="flex items-center justify-center shrink-0 h-14 px-2 transition-all duration-300 cursor-default"
              style={{ minWidth: "140px" }}
            >
              <img
                src={brand.logo}
                alt={brand.name}
                className="max-h-12 max-w-[132px] w-auto h-auto object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}